// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1ZWr2","notes":"Notes_notes__2-E-J"};